import { render } from "./IconActivate.vue?vue&type=template&id=fb0b0114"
import script from "./IconActivate.vue?vue&type=script&lang=ts"
export * from "./IconActivate.vue?vue&type=script&lang=ts"
script.render = render

export default script